import { CampaignGroupIdSchema as s } from "@hprofits/shared";
import { z as e } from "zod";
const h = [
  "domain",
  "sys_adunit_number",
  "ad_unit_type",
  // Exact format names (the banner size lives only in the name, e.g. "UVB Mobile (300x100)").
  "ad_unit_format",
  "traffic_source",
  // 0 = Direct, >0 = SSP id, -1 = SSP with unknown feed; any non-zero value requires SplitTrafficSourceBySsp.
  "traffic_source_id",
  "sys_country",
  "device_type_name",
  "os_type_name",
  "sys_browser_type",
  "sys_language",
  "content_type",
  "impressions"
], k = e.enum(h), _e = 0, d = e.enum(["=", "!=", "like", "eq", "neq", "<=", ">=", "replace"]), m = e.object({
  key: k,
  condition: d,
  values: e.array(e.union([e.string(), e.number()]))
}).refine((t) => t.key !== "traffic_source_id" || t.values.every((a) => Number.isInteger(a)), {
  message: "traffic_source_id values must be integers",
  path: ["values"]
}).readonly(), v = e.enum(["impressions"]), G = e.object({
  key: v,
  direction: e.enum(["asc", "desc"])
}).readonly(), ge = e.object({
  filters: e.array(m).default([]),
  order: e.array(G).default([]),
  limit: e.number().int().positive().optional(),
  offset: e.number().int().nonnegative().optional()
}).readonly(), g = 100, b = e.enum(["domain", "spot"]), be = e.discriminatedUnion("mode", [
  e.object({
    mode: e.literal(b.enum.domain),
    keys: e.array(e.string().min(1)).max(g),
    filters: e.array(m).default([])
  }),
  e.object({
    mode: e.literal(b.enum.spot),
    keys: e.array(e.int()).max(g),
    filters: e.array(m).default([])
  })
]).readonly(), q = e.object({
  key: e.string(),
  // Row count of the matching expansion endpoint (its metadata.total), not children.length.
  total: e.int().nonnegative(),
  children: e.array(e.string()).readonly()
}).readonly(), Re = e.object({
  items: e.array(q).readonly()
}).readonly(), N = e.enum([...h, "sys_campaign_number"]), D = e.enum(["impressions", "date"]), P = e.object({
  key: N,
  condition: d,
  values: e.array(e.union([e.string(), e.number()]))
}).readonly(), U = e.object({
  key: D,
  direction: e.enum(["asc", "desc"])
}).readonly(), he = e.object({
  code: e.string(),
  from: e.string(),
  to: e.string(),
  groups: e.array(e.string()),
  metrics: e.array(e.string()),
  filters: e.array(P).default([]),
  order: e.array(U).default([]),
  metrics_macro: e.string().optional(),
  limit: e.number().int().positive().optional(),
  offset: e.number().int().nonnegative().optional()
}).readonly(), X = e.object({
  title: e.string(),
  tag: e.string().optional()
}).readonly(), L = e.union([e.string(), X]), f = e.object({
  dimensions: e.record(e.string(), L),
  metrics: e.record(e.string(), e.number()),
  keys: e.record(e.string(), e.unknown())
}).readonly(), l = e.object({
  limit: e.number(),
  offset: e.number(),
  count: e.number(),
  total: e.number()
}).readonly(), j = {
  stats: e.array(f),
  totals: e.record(e.string(), e.number()),
  metadata: l
}, fe = e.object(j).readonly(), je = e.object({ ...j, querySql: e.array(e.string()).optional() }).readonly(), Q = 2, u = 64, F = e.enum(["day", "weekHourly", "week", "month"]), i = e.enum([
  "common_advert_report_new",
  "common_advert_admin_report_new"
]), Ee = e.object({
  campaignId: s,
  period: F,
  metrics: e.array(e.string().trim().min(1).max(u)).min(1).max(Q),
  reportCode: i
}).readonly(), K = e.object({
  keys: e.record(e.string(), e.string()),
  metrics: e.record(e.string(), e.number())
}).readonly(), Ce = e.object({
  stats: e.array(K)
}).readonly(), Te = e.object({
  reportCode: i
}).readonly(), w = e.object({
  key: e.string(),
  name: e.string(),
  description: e.string(),
  /** Display format: `integer`, `money`, `percent` (ae-stat may add others). */
  valueType: e.string(),
  /** `sum` for an additive metric; anything else is a rate the server computes for the total. */
  valueTotal: e.string()
}).readonly(), Me = e.object({
  metrics: e.array(w)
}).readonly(), E = 100, o = 366, Y = 864e5, r = (t, a) => (Date.parse(a) - Date.parse(t)) / Y, Ae = e.object({
  campaignId: s,
  reportCode: i,
  from: e.iso.date(),
  to: e.iso.date(),
  metrics: e.array(e.string().trim().min(1).max(u)).min(1).max(E)
}).refine(({ from: t, to: a }) => r(t, a) >= 0, { error: "from must not be after to", path: ["to"] }).refine(({ from: t, to: a }) => r(t, a) <= o, {
  error: `the range must not exceed ${o} days`,
  path: ["from"]
}).readonly(), H = e.object({
  ruleId: e.string(),
  metrics: e.record(e.string(), e.number())
}).readonly(), xe = e.object({
  rows: e.array(H)
}).readonly(), V = 100, Ie = e.object({
  campaignIds: e.array(s).min(1).max(V),
  reportCode: i,
  from: e.iso.date(),
  to: e.iso.date(),
  metrics: e.array(e.string().trim().min(1).max(u)).min(1).max(E)
}).refine(({ from: t, to: a }) => r(t, a) >= 0, { error: "from must not be after to", path: ["to"] }).refine(({ from: t, to: a }) => r(t, a) <= o, {
  error: `the range must not exceed ${o} days`,
  path: ["from"]
}).readonly(), Z = e.object({
  campaignId: s,
  metrics: e.record(e.string(), e.number())
}).readonly(), Oe = e.object({
  rows: e.array(Z)
}).readonly(), B = 128, $ = 200, C = 100, c = 1e3, z = 5, y = 4, J = 200, W = 500, n = e.string().trim().min(1).max(B), ee = e.object({
  code: e.string(),
  name: e.string(),
  categoryCode: e.string(),
  defaultMetrics: e.array(e.string())
}).readonly(), ke = e.object({
  reports: e.array(ee)
}).readonly(), ve = e.object({
  reportCode: n
}).readonly(), te = e.object({
  key: e.string(),
  name: e.string()
}).readonly(), Ge = e.object({
  dimensions: e.array(te)
}).readonly(), ae = e.object({
  key: n,
  condition: d,
  values: e.array(e.union([e.string(), e.number()])).max(c)
}).readonly(), T = e.object({
  key: n,
  direction: e.enum(["asc", "desc"])
}).readonly(), M = e.object({
  reportCode: n,
  from: e.iso.datetime(),
  to: e.iso.datetime(),
  filters: e.array(ae).max(C).default([]),
  limit: e.int().positive().max(W),
  offset: e.int().nonnegative().default(0)
}), qe = M.extend({
  groups: e.array(n).min(1).max(y),
  metrics: e.array(n).min(1).max(J),
  order: e.array(T).max(z).default([])
}).refine(({ from: t, to: a }) => Date.parse(t) <= Date.parse(a), { error: "from must not be after to", path: ["to"] }).readonly(), Ne = e.object({
  stats: e.array(f),
  totals: e.record(e.string(), e.number()),
  metadata: l,
  querySql: e.array(e.string()).optional()
}).readonly(), De = M.extend({
  dimension: n,
  search: e.string().trim().max($).optional()
}).refine(({ from: t, to: a }) => Date.parse(t) <= Date.parse(a), { error: "from must not be after to", path: ["to"] }).readonly(), ne = e.object({
  id: e.union([e.string(), e.number()]),
  name: e.string()
}).readonly(), Pe = e.object({
  values: e.array(ne),
  metadata: l
}).readonly(), R = 100, oe = /^[a-f0-9]{32}$/, A = e.string().regex(oe), x = e.object({
  reportCode: n,
  from: e.union([e.iso.date(), e.iso.datetime({ local: !0, precision: -1 })]),
  to: e.union([e.iso.date(), e.iso.datetime({ local: !0, precision: -1 })]),
  groups: e.array(n).max(y),
  dimensions: e.record(
    n,
    e.object({
      values: e.array(e.union([e.string(), e.number()])).min(1).max(c),
      include: e.boolean(),
      paused: e.boolean().optional()
    }).readonly()
  ).refine((t) => Object.keys(t).length <= R),
  metrics: e.record(
    n,
    e.object({ min: e.number().nullable(), max: e.number().nullable(), paused: e.boolean().optional() }).readonly()
  ).refine((t) => Object.keys(t).length <= R),
  sort: T.optional()
}).readonly(), Ue = e.object({ state: x }).readonly(), Xe = e.object({ queryId: A }).readonly(), Le = e.object({ queryId: A }).readonly(), Qe = e.object({ state: x }).readonly(), re = 255, S = e.coerce.number().int().positive(), se = e.object({
  key: n,
  name: e.string()
}).readonly(), ie = e.object({
  id: e.union([e.string(), e.number()]),
  name: e.string()
}).readonly(), ce = e.object({
  name: e.string(),
  include: e.boolean(),
  values: e.array(ie).min(1).max(c)
}).readonly(), p = e.object({
  name: e.string().trim().min(1).max(re),
  reportCode: n,
  groups: e.array(se).max(y),
  dimensions: e.record(n, ce).refine((t) => Object.keys(t).length <= C)
}), me = p.readonly(), I = p.extend({ id: S }).readonly(), Fe = e.object({ segments: e.array(I) }).readonly(), Ke = me, we = p.extend({
  segmentId: S
}).readonly(), Ye = e.object({ segmentId: S }).readonly(), He = e.object({ segment: I }).readonly(), Ve = [25, 50, 80, 100], de = 100, le = 500, _ = e.enum([
  "sys_country",
  "ad_unit_format",
  "ad_unit_type",
  "device_type_name",
  "os_type_name",
  "domain",
  "traffic_source",
  "content_type"
]), ue = e.enum([
  "sys_adunit_number",
  "traffic_source",
  "ad_unit_type",
  "ad_unit_format",
  "content_type",
  "impressions",
  "bid_floor_min_cpm",
  "bid_floor_max_cpm"
]), O = e.object({
  key: _,
  include: e.boolean(),
  values: e.array(e.union([e.string(), e.number()])).min(1).max(c)
}).readonly(), ye = e.object({
  key: ue,
  direction: e.enum(["asc", "desc"])
}).readonly(), Ze = e.object({
  filters: e.array(O).max(_.options.length).default([]),
  sort: ye.default({ key: "impressions", direction: "desc" }),
  limit: e.number().int().min(1).max(de),
  offset: e.number().int().nonnegative()
}).readonly(), Be = e.object({
  spotId: n,
  filters: e.array(O).max(_.options.length).default([]),
  limit: e.number().int().min(1).max(le),
  offset: e.number().int().nonnegative()
}).readonly();
export {
  je as AeStatGroupedResponseSchema,
  Ae as CampaignRollupRequestSchema,
  xe as CampaignRollupResponseSchema,
  H as CampaignRollupRowSchema,
  F as CampaignTimeseriesPeriodSchema,
  i as CampaignTimeseriesReportCodeSchema,
  Ee as CampaignTimeseriesRequestSchema,
  Ce as CampaignTimeseriesResponseSchema,
  K as CampaignTimeseriesRowSchema,
  Ie as CampaignTotalsRequestSchema,
  Oe as CampaignTotalsResponseSchema,
  Z as CampaignTotalsRowSchema,
  _e as DIRECT_TRAFFIC_SOURCE_ID,
  X as DimensionNameObjectSchema,
  L as DimensionNameSchema,
  le as MARKETPLACE_DOMAINS_MAX_PAGE_SIZE,
  de as MARKETPLACE_MAX_PAGE_SIZE,
  Ve as MARKETPLACE_PAGE_SIZES,
  V as MAX_CAMPAIGN_TOTALS_IDS,
  g as MAX_CHILD_COUNTS_KEYS,
  y as MAX_REPORT_GROUP_COUNT,
  J as MAX_REPORT_METRIC_COUNT,
  W as MAX_REPORT_PAGE_SIZE,
  E as MAX_ROLLUP_METRIC_COUNT,
  o as MAX_ROLLUP_RANGE_DAYS,
  Q as MAX_TIMESERIES_METRIC_COUNT,
  Be as MarketplaceDomainsRequestSchema,
  _ as MarketplaceFilterKeySchema,
  O as MarketplaceFilterSchema,
  Ze as MarketplaceRequestSchema,
  ue as MarketplaceSortKeySchema,
  ye as MarketplaceSortSchema,
  l as MetadataSchema,
  ge as StatBusinessRequestSchema,
  q as StatChildCountsItemSchema,
  b as StatChildCountsModeSchema,
  be as StatChildCountsRequestSchema,
  Re as StatChildCountsResponseSchema,
  f as StatGroupSchema,
  N as StatGroupedFilterKeySchema,
  P as StatGroupedFilterSchema,
  D as StatGroupedOrderKeySchema,
  U as StatGroupedOrderSchema,
  he as StatGroupedRequestSchema,
  fe as StatGroupedResponseSchema,
  d as StatQueryFilterConditionSchema,
  k as StatQueryFilterKeySchema,
  m as StatQueryFilterSchema,
  Le as StatQueryGetRequestSchema,
  Qe as StatQueryGetResponseSchema,
  A as StatQueryIdSchema,
  v as StatQueryOrderKeySchema,
  G as StatQueryOrderSchema,
  Ue as StatQuerySaveRequestSchema,
  Xe as StatQuerySaveResponseSchema,
  x as StatQueryStateSchema,
  te as StatReportDimensionSchema,
  Ge as StatReportDimensionsResponseSchema,
  ae as StatReportFilterSchema,
  qe as StatReportGroupedRequestSchema,
  Ne as StatReportGroupedResponseSchema,
  n as StatReportKeySchema,
  T as StatReportOrderSchema,
  ve as StatReportRequestSchema,
  ee as StatReportSchema,
  ne as StatReportValueSchema,
  De as StatReportValuesRequestSchema,
  Pe as StatReportValuesResponseSchema,
  ke as StatReportsResponseSchema,
  Ke as StatSegmentCreateRequestSchema,
  Ye as StatSegmentDeleteRequestSchema,
  ce as StatSegmentDimensionSchema,
  se as StatSegmentGroupSchema,
  S as StatSegmentIdSchema,
  me as StatSegmentInputSchema,
  He as StatSegmentResponseSchema,
  I as StatSegmentSchema,
  we as StatSegmentUpdateRequestSchema,
  ie as StatSegmentValueSchema,
  Fe as StatSegmentsResponseSchema,
  w as StatisticsMetricSchema,
  Te as StatisticsMetricsRequestSchema,
  Me as StatisticsMetricsResponseSchema
};
//# sourceMappingURL=schemas.js.map
